import React from 'react';
import useDownloadTourbook from '@shared/useDownloadTourbook';
import { object, SchemaOf, string } from 'yup';
import { Form, TextInput, SubmitButton } from '@components/shared/forms';

type FormValues = {
  tourbookId: string;
};

export default function TourbookExportTool() {
  const downloadTourbook = useDownloadTourbook();

  const schema: SchemaOf<FormValues> = object().shape({
    tourbookId: string().required(),
  });

  const onSubmit = async (values, helpers) => {
    await downloadTourbook({
      tourbookId: values.tourbookId,
      onFinish: () => helpers.resetForm(),
      onFailure: () =>
        helpers.setFieldError(
          'tourbookId',
          'There is no tourbook with that id or something went wrong trying to fetch it',
        ),
    });
  };
  return (
    <div>
      <Form<FormValues>
        initialValues={{ tourbookId: '' }}
        validationSchema={schema}
        id="tourbookExport"
        onSubmit={onSubmit}
      >
        <TextInput autoComplete={false} name="tourbookId" labelText="Tourbook Id" />
        {/* FIXME: Remove this line because its a <Trans /> or remove this literal */}
        {/* eslint-disable-next-line react/jsx-no-literals */}
        <SubmitButton>Submit</SubmitButton>
      </Form>
    </div>
  );
}
